import { forwardRef, type InputHTMLAttributes } from 'react';
import { colors, radius } from './tokens';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'type'> & {
  size?: number;
  label?: string;
};

export const Checkbox = forwardRef<HTMLInputElement, Props>(function Checkbox(
  { size = 16, label, checked, disabled, style, ...rest },
  ref,
) {
  const box = {
    width: size,
    height: size,
    borderRadius: radius.xs / 2,
    border: `1.25px solid ${checked ? colors.accent : colors.line2}`,
    background: checked ? colors.accent : colors.surface,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background 0.12s, border-color 0.12s',
    flexShrink: 0,
    opacity: disabled ? 0.5 : 1,
  } as const;
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: label ? 8 : 0,
        cursor: disabled ? 'not-allowed' : 'pointer',
        userSelect: 'none',
        ...style,
      }}
    >
      <input
        ref={ref}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        style={{ position: 'absolute', opacity: 0, width: 0, height: 0, pointerEvents: 'none' }}
        {...rest}
      />
      <span style={box} aria-hidden>
        {checked && (
          <svg width={size * 0.65} height={size * 0.65} viewBox="0 0 16 16" fill="none">
            <path
              d="M3 8.5l3.2 3.2L13 5"
              stroke={colors.surface}
              strokeWidth={2.2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
      {label && <span style={{ fontSize: 13, color: colors.ink2 }}>{label}</span>}
    </label>
  );
});
